export { templatesList } from '@/app/services/vidu';
